import * as React from 'react';
import styles from '../components/foundation/grid/_grid.module.scss';

type MediaQueryRules = {
    custom?: string,
    max?: string,
    min?: string,
}

const gridSizes = ['xs', 'sm', 'md', 'lg', 'xl'];

export const useMediaQuery = ({
    custom,
    max,
    min
}: MediaQueryRules) => {
    
    const getMediaQuery = () => {
        let minQuery = "";
        let maxQuery = "";
        let fullMediaQuery = ""
        if(custom) {
            fullMediaQuery = custom;
        } else if (min || max) {
            if(min) {
                if(gridSizes.indexOf(min) !== -1) {
                    minQuery = ` and (min-width: ${styles[`grid-breakpoint-${min}`]})`;
                } else {
                    minQuery = ` and (min-width: ${min})`;
                }
            } 
            if (max) {
                if(gridSizes.indexOf(max) !== -1) {
                    maxQuery = ` and (max-width: ${styles[`grid-breakpoint-${max}-max`]})`;
                } else {
                    maxQuery = ` and (max-width: ${max})`;
                }
            }

            fullMediaQuery = `all${minQuery}${maxQuery}`;
        }

        return fullMediaQuery;
    }

    let mediaQuery = getMediaQuery();
    let enableQuery = mediaQuery && typeof window !== 'undefined';
    const [matches, setMatches] = React.useState<boolean | undefined>();
    
    React.useEffect(() => {       
        if(enableQuery) {
            const mediaMatch = window?.matchMedia(mediaQuery);

            if(mediaMatch) {
                const updateMatch = () => {
                    let mediaMatches = mediaMatch?.matches;
    
                    setMatches(mediaMatches);
                };
              
                updateMatch();

                if(mediaMatch.addEventListener) {
                    mediaMatch.addEventListener("change", updateMatch);
        
                    return () => {
                        mediaMatch.removeEventListener("change", updateMatch);
                    }
                } else {
                    // Fallback for older browsers that don't yet support MediaQueryList addEventListener
                    mediaMatch.addListener(updateMatch);
        
                    return () => {
                        mediaMatch.removeListener(updateMatch);
                    }
                }

            }
        }
    }, []);

    return matches;
};